<script>
    import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
    import Fa from 'svelte-fa'

    /**
     * @typedef {Object} Props
     * @property {string} [title]
     * @property {string} [description]
     * @property {any} href
     * @property {string} [badge]
     */

    /** @type {Props} */
    let { title = '', description = '', href, badge } = $props()
</script>

<a {href} class="w-100 text-decoration-none">
    <div class="list-group-item list-group-item-action border-0 shadow">
        <div class="row align-items-center">
            <div class="col-10 text-start">
                <div class="d-inline-flex align-items-center">
                    <strong class="fw-semibold">{title}</strong>
                    {#if badge}
                        <span class="badge bg-success ms-2">{badge}</span>
                    {/if}
                </div>
                <br />
                <small class="text-secondary">{description}</small>
            </div>
            <div class="col-2 text-center">
                <Fa icon={faAngleRight} />
            </div>
        </div>
    </div>
</a>

<style lang="scss">
    .list-group-item {
        font-size: 95%;
        background-color: rgba(var(--bs-white-rgb));
        padding: 0.9em;
        margin-bottom: 0.7rem;
    }

    .list-group-item:hover {
        background-color: #f8f9fa;
    }

    a {
        color: inherit;
    }
</style>
